<app-scrollable-container [noFooter]="true"
  class="command-page flex-column justify-start align-stretch">
  <mat-toolbar header
    class="command-header-toolbar flex-row justify-start align-center gap-10">
    <mat-toolbar-row class="flex-row justify-start align-center">
      <div>
        <!-- button retour-->
        <app-back-button class="align-self-start"
          [stopNavigation]="true"
          (click)="onExit()"
        [style]="{ padding: 0 }"></app-back-button>
      </div>
      <span [id]="order?.orderId"
      class="command-header-toolbar-title">{{ "COMMAND.DETAIL_TITLE" | transloco : { deliveryDate: (order?.deliveryDate | translocoDate: { dateStyle: 'short' }), orderNumber: order.ticketNumber } }}</span>
    </mat-toolbar-row>
  </mat-toolbar>
  <div content
    class="command-container">
    @if (order.processingState.isDailyPreparationOrder) {
      <app-command-track-order-bar
        [order]="order"
        [title]="'COMMAND.ORDER_PREPARATION.TRACK_ORDER'"
        [showOrderDescription]="false"
      (trackOrder)="goToTrackOrder()"></app-command-track-order-bar>
    }
    <!--Statut-->
    <app-command-detail-state [order]="order"></app-command-detail-state>
    <app-command-detail-receipt [order]="order"></app-command-detail-receipt>

    <!--Livraison-->
    <app-command-detail-delivery [order]="order"
      [hideComment]="!order.comment"
      [isReadOnly]="true"
    [customerDisplayName]="order.customer.firstName + ' ' + order.customer.lastName"></app-command-detail-delivery>
    <mat-divider class="command-divider"></mat-divider>
    <!--Produits-->
    <app-cart-product-list [cartProductList]="cartProductList"
    [currencyCode]="order.restaurant.currency"></app-cart-product-list>
    <!--Total-->
    <app-cart-product-total [totalVatPrice]="order.totalTax"
      [totalPrice]="order.totalInclTaxWithDiscount"
      [cartProductList]="cartProductList"
      [discounts]="order.discounts"
      [fees]="order.fees"
      [currencyCode]="order.restaurant.currency"
    [showVAT]="order.restaurant.showVAT"></app-cart-product-total>
  </div>
</app-scrollable-container>
